import { useState } from 'react';
import { isAxiosError } from 'axios';
import { IAPIError } from '../interface/common';

// Lets the loading overlay unmount before the modal opens, otherwise the two transitions overlap
const ERROR_MODAL_DELAY_MS = 300;

export const useApiErrorModal = (resolveErrorMessage: (apiErrorType?: string) => string) => {
  const [isErrorModalVisible, setIsErrorModalVisible] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const showErrorModal = (error: unknown) => {
    // Errors the interceptor already handled (401/403) arrive as a plain Error after it has
    // navigated away, so a modal on top of them would belong to a screen the user has left.
    if (!isAxiosError<IAPIError>(error)) return;

    const message = resolveErrorMessage(error.response?.data?.type);
    setTimeout(() => {
      setErrorMessage(message);
      setIsErrorModalVisible(true);
    }, ERROR_MODAL_DELAY_MS);
  };

  const closeErrorModal = () => {
    setIsErrorModalVisible(false);
    setErrorMessage('');
  };

  return { isErrorModalVisible, errorMessage, showErrorModal, closeErrorModal };
};
